export function status(response: LooseObject) {
    if (response.ok) {
        return response;
    } else {
        var error = new Error(response.statusText || response.status);
        error['response'] = response;
        throw error;
    }
}

export function headers(options: LooseObject = {}) {
    options.headers = options.headers || {};
    options.headers['X-Requested-With'] = 'XMLHttpRequest';
    return options;
}

export function credentials(options: LooseObject = {}) {
    if (options == null) options = {};
    if (!options['credentials'] || options['credentials'] === null)
        options['credentials'] = 'same-origin';
    return options;
}

export function json(response: LooseObject) {
    return response.json();
}

export function text(response: LooseObject) {
    return response.text() as string;
}

export const fetchText = function (url: string, options: RequestInit = {}) {
    options = headers(credentials(options));
    options.credentials = 'include';
    return fetch(url, options).then(status).then(text);
};

export const fetchJSON = function (url: string, options: RequestInit = {}) {
    options = headers(credentials(options));
    options.headers['Accept'] = 'application/json';
    options.credentials = 'include';
    return fetch(url, options).then(status).then(json);
};

export const fetchPoll = function (url: string, options: RequestInit) {
    return new Promise(function (resolve, reject) {
        function poll(wait) {
            function done(response) {
                switch (response.status) {
                    case 200:
                        resolve(response);
                        break;
                    case 202:
                        setTimeout(poll, wait, wait * 1.5);
                        break;
                    default:
                        var error = new Error(
                            response.statusText || response.status
                        );
                        error['response'] = response;
                        reject(error);
                        break;
                }
            }
            options.credentials = 'include';
            fetch(url, options).then(done, reject);
        }
        poll(1000);
    });
};
